import React from "react";
import { Button } from "shared";

export const CensusActions = ({ isHidden, hasMarkedFields, isSubmitting, onConfirm, onReportIssues, areDataCorrectLabel, allCorrectLabel, confirmProblemsLabel }) => {
  if (isHidden) return null;

  return (
    <section className="scan__actions">
      {!hasMarkedFields && (
        <h3 className="scan__actions-title">{areDataCorrectLabel}</h3>
      )}
      <div className="scan__actions-buttons">
        {!hasMarkedFields && (
          <Button
            buttonText={allCorrectLabel}
            buttonColor={"green"}
            event={onConfirm}
            isDisabled={isSubmitting}
          />
        )}
        {hasMarkedFields && (
          <Button
            buttonText={confirmProblemsLabel}
            buttonColor={"red"}
            event={onReportIssues}
            isDisabled={isSubmitting}
          />
        )}
      </div>
    </section>
  );
};
